import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SearchIcon from "../../../../assets/img/icons/search.svg";
import SearchCross from "../../../../assets/img/icons/SearchCross.svg";
import RefreshIcon from "../../../../assets/img/icons/reload.svg";
import { ReactComponent as SearchAdvance } from "../../../../assets/img/icons/SearchAdvance.svg";
import { Button } from "antd";
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import { AUDIENCE_PEOPLE, PEOPLE_AUDIENCE } from "constants/actionTypes";
import { AUDIENCE_LISTS_ADD, AUDIENCE_LISTS_DETAILS, AUDIENCE_LISTS_SEARCH } from "constants/types";
import {
  getAudienceLists,
  resetAudienceListDetailsPeopleSearch,
  resetAudienceLists,
  resetAudiencePeopleTabData,
} from "../Lists/actions";
import { setAudiencePeopleSearchTerm } from "../actions";

interface IAudienceSearchBar {
  ShowSearchIcon?: boolean;
  ShowRefreshIcon?: boolean;
  isList?: boolean;
  showAdvance?: boolean;
  Placeholder?: string;
  searchTerm?: string;
  resetTerm?: any;
  submitHandler?: (value: any) => void;
  clearHandler?: () => void;
  isListDetials?: boolean;
  searchTermListDetails?: string;
}

const AudienceSearchBar: React.FC<IAudienceSearchBar> = ({
  ShowSearchIcon,
  isList,
  ShowRefreshIcon,
  Placeholder,
  showAdvance,
  searchTerm,
  resetTerm,
  submitHandler,
  clearHandler,
  isListDetials,
  searchTermListDetails,
}) => {
  const [value, setValue] = useState("");
  const removeSearch: boolean = useSelector((state: RootState) => state.audienceLists.removeSearch);

  const handleInput = (e: any) => {
    let value = e.target.value;
    setValue(value);
    if (value.length === 0) {
      clearSearch();
    }
  };

  const updateSearchTerm = () => {
    if (isList) {
      if (isListDetials) {
        store.dispatch({
          type: AUDIENCE_LISTS_DETAILS.SET_SEARCH_TERM,
          searchTermListDetails: value,
        });
      } else {
        store.dispatch({
          type: AUDIENCE_LISTS_SEARCH.SET_SEARCH,
          searchTerm: value,
        });
      }
    } else {
      // resetting the list everytime search term is changed.
      if (searchTerm?.trim() !== value.trim()) {
        resetAudiencePeopleTabData();
      }
      setAudiencePeopleSearchTerm(value.trim());
      setValue(value.trim());
    }
  };

  const clearSearch = () => {
    setValue("");
    if (searchTerm && searchTerm?.length > 0) {
      resetAudiencePeopleTabData();
      setAudiencePeopleSearchTerm("");
      if (clearHandler) clearHandler();
    }
    resetAudienceListDetailsPeopleSearch();
    resetAudienceLists();
    getAudienceLists({ offset: 0, limit: 20 });
  };

  const refreshSearch = (e: any) => {
    e.preventDefault();
    updateSearchTerm();
    if (submitHandler && !isListDetials) submitHandler(value);
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (submitHandler && !isListDetials) submitHandler(value);
  };

  const resetSearchedContactsOnPageChange = () => {
    setAudiencePeopleSearchTerm("");
    // resetting the list everytime search term is changed.
    resetAudiencePeopleTabData();
  };

  useEffect(() => {
    if (resetTerm) {
      setValue("");
      // reset searched contacts when change tab form People to Lists in a searched contact scenario
      resetSearchedContactsOnPageChange();
    }
  }, [resetTerm]);

  useEffect(() => {
    if (removeSearch) {
      clearSearch();
      store.dispatch({
        type: AUDIENCE_LISTS_ADD.RESET_REMOVE_SEARCH,
      });
    }
  }, [removeSearch]);

  useEffect(() => {
    if (value.length > 0 && searchTermListDetails === "") setValue("");
  }, [searchTermListDetails]);

  return (
    <Wrapper
      ShowSearchIcon={ShowSearchIcon}
      ShowRefreshIcon={ShowRefreshIcon}
      showAdvance={showAdvance}
      className="list-search-bar"
    >
      <div className="search-wraper">
        <form onSubmit={onSubmit}>
          <div className="search-bar">
            <span className="refresh-search" onClick={(e) => (ShowSearchIcon ? clearSearch : refreshSearch(e))}>
              {ShowSearchIcon ? <img src={SearchIcon} alt="icon" /> : ""}
              {ShowRefreshIcon ? <img src={RefreshIcon} alt="icon" /> : ""}
            </span>
            <input
              type="text"
              name="search"
              value={value}
              className="search-input"
              placeholder={Placeholder}
              data-qa="audience-search-input"
              onChange={handleInput}
              onKeyPress={(e: any) => {
                if (e.key === "Enter") updateSearchTerm();
              }}
            // onKeyUp={onKeyUp}
            />
            {value.length > 0 ? (
              <span className="clear-search" onClick={clearSearch}>
                <img src={SearchCross} alt="icon" />
              </span>
            ) : null}
            {showAdvance ? (
              <WrapperAdvance>
                <Button>
                  <span className="advance_icon">
                    <SearchAdvance />
                  </span>
                  Advanced
                </Button>
              </WrapperAdvance>
            ) : null}
          </div>
        </form>
      </div>
    </Wrapper>
  );
};

export default AudienceSearchBar;

const Wrapper = styled.div<{
  ShowSearchIcon?: boolean;
  ShowRefreshIcon?: boolean;
  showAdvance?: boolean;
}>`
  width: 100%;
  .search-wraper {
    position: relative;
    width: 100%;
    .search-results {
      border-radius: 22px;
      position: absolute;
      top: -80px;
      left: 0;
      float: left;
      width: 100%;
      border: 1px solid #dadada;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transition: 0.5s;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        z-index: 1;
        visibility: visible;
      }
      ul.results-list {
        background: #fff;
        padding: 30px 55px 10px 55px;
        margin: 0;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          float: left;
          width: 100%;
          display: block;
          cursor: pointer;
          transition: 0.5s;
        }
      }
      .relevant-theme,
      .relevant-company {
        border-top: 1px solid #dadada;
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .search-hint {
        background: #def6e6;
        padding: 18px 25px 36px 25px;
        border-radius: 22px 22px 0 0;
        float: left;
        width: 100%;
        svg {
          float: left;
          width: 35px;
          height: 39px;
        }
        ul {
          margin: 0;
          float: left;
          li {
            color: #09a43a;
            font-size: 14px;
            font-weight: 400;
            list-style: none;
            strong {
              font-weight: 700;
            }
          }
        }
      }
    }
    .search-bar {
      border-radius: 27px;
      background: #ffffff;
      border: 1px solid #dadada;
      display: block;
      float: left;
      overflow: hidden;
      position: relative;
      span.clear-search {
        margin: 9px 8px 9px 8px;
        float: left;
        cursor: pointer;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin: 3px 8px 3px 8px;
          float: right;
        }
        img {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 9px;
            height: auto;
          }
        }
      }
      span.refresh-search {
        padding-right: 5px;
        border-right: ${(props) => (props.ShowSearchIcon || props.ShowRefreshIcon ? "1px solid #dadada" : "none")};
        margin: 8px !important;
        float: left;
        cursor: pointer;
        svg path {
          fill: #424b50;
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          line-height: 13px;
        }
        img {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 14px;
            height: auto;
            vertical-align: bottom;
          }
        }
      }
      .search-input {
        float: left;
        border: none;
        outline: none;
        width: ${(props) => (props.showAdvance ? "calc(100% - 213px)" : "calc(100% - 85px)")};
        display: block;
        margin-top: 5px;
        color: #424b50;
        font-weight: 400;
        font-size: 18px;
        font-family: "robotoregular";
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 13px;
          margin-top: 3px;
        }
        &::-webkit-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &::-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-ms-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:hover,
        &:active,
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
`;

const WrapperAdvance = styled.div`
  font-family: "robotoblack";
  margin-right: 20px;
  float: right;
  display: inline-block;
  cursor: pointer;
  transition: 0.5s;
  button {
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    box-shadow: none;
    &:after {
      display: none;
    }
    span {
      font-size: 16px;
      font-weight: 500;
      line-height: 40px;
      color: #7e7e7e;
      &.advance_icon {
        border-left: 1px solid #dddddd;
        padding-left: 10px;
        margin: 9px 9px 9px 0;
        float: left;
        svg {
          float: left;
        }
      }
    }
  }
`;
